
    import { mapState, mapActions } from 'vuex';
    import { ValidationObserver, ValidationProvider } from 'vee-validate';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import { faShieldCheck as fasShieldCheck } from '@fortawesome/pro-solid-svg-icons';
    import {
        faTriangleExclamation as farTriangleExclamation,
        faCircleCheck as farCircleCheck,
    } from '@fortawesome/pro-regular-svg-icons';
    import C1Dropdown from '@/C1Components/C1Dropdown';
    import C1FormInput from '@/C1Components/C1FormInput';
    import C1Spinner from '@/C1Components/C1Spinner';

    export default {
        name: 'JobViewScamWarning',

        components: {
            C1Spinner,
            C1FormInput,
            C1Dropdown,
            FontAwesomeIcon,
            ValidationProvider,
            ValidationObserver,
        },

        data() {
            return {
                isSubmitting: false,
                form: {
                    reason: {},
                    comment: '',
                    email: '',
                },
                isModalOpen: false,
                icons: {
                    fasShieldCheck,
                    farTriangleExclamation,
                    farCircleCheck,
                },
                isSuccess: false,
                reasons: [
                    {
                        label: 'Look suspicious',
                        value: 'look suspicious',
                    },
                    {
                        label: 'Requests money or sensitive information',
                        value: 'requests money or sensitive information',
                    },
                    {
                        label: 'Inaccurate or misleading job details',
                        value: 'inaccurate or misleading job details',
                    },
                    {
                        label: 'Other (please describe in comments)',
                        value: 'other',
                    },
                ],
            };
        },

        computed: {
            ...mapState({
                $_me: state => state.me.user,
                $_job: state => state.job.job,
            }),
        },

        methods: {
            ...mapActions('job', {
                $_reportScamJob: 'reportScamJob',
            }),

            openModal() {
                this.isModalOpen = true;
            },

            closeModal() {
                this.isModalOpen = false;
            },

            async handleSubmit() {
                const validate = await this.$refs.reportForm.validate();
                if (!validate) {
                    return;
                }

                this.isSubmitting = true;

                try {
                    const payload = {
                        job_uuid: this.$_job.uuid || '',
                        seeker_id: this.$_me.id || null,
                        comment: this.form.comment || '',
                        email: this.form.email || '',
                        reason: this.form.reason.value || 'other',
                    };
                    await this.$_reportScamJob(payload);
                    this.isSuccess = true;
                } catch (error) {
                    console.error('Failed to submit report:', error);
                } finally {
                    this.isSubmitting = false;
                }
            },
        },
    };
